import { Link, useNavigate } from "react-router-dom";

const CATEGORIES = [
  { label: "悬疑", to: "/category/works?genre=悬疑" },
  { label: "犯罪", to: "/category/works?genre=犯罪" },
  { label: "科幻", to: "/category/works?genre=科幻" },
  { label: "爱情", to: "/category/works?genre=爱情" },
  { label: "古装", to: "/category/works?genre=古装" },
  { label: "动作", to: "/category/works?genre=动作" },
  { label: "奇幻", to: "/category/works?genre=奇幻" },
  { label: "历史", to: "/category/works?genre=历史" },
];

export default function CategoryNav() {
  const navigate = useNavigate();
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="px-4 py-3 border-b border-background-200 bg-background-100">
        <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-layout-grid-line text-secondary-500" />
          分类导航
        </h3>
      </div>
      <div className="p-4">
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((cat) => (
            <Link
              key={cat.label}
              to={cat.to}
              className="px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 text-sm hover:bg-primary-500 hover:text-background-50 transition-colors"
            >
              {cat.label}
            </Link>
          ))}
        </div>
      </div>
      <div className="px-4 pb-4">
        <button
          type="button"
          onClick={() => navigate("/search")}
          className="w-full flex items-center justify-center gap-2 bg-primary-500 text-background-50 text-sm font-medium py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-search-line" />
          去搜索影视内容
        </button>
      </div>
    </div>
  );
}